export enum BulkActionType {
  SendCommunications = 'SendCommunications',
  AssignLocations = 'AssignLocations'
}
